import "lightgallery.js";
import "lg-thumbnail.js";
import "lg-video.js";
import(/* webpackPrefetch: true */ "./lightgallery.scss")

export default {};
